import React, { useEffect } from "react";
import "./ItemFormNotice.css";

// Non-modal feedback: keep the current field focused and the form usable.
export default function ItemFormNotice({ message, detail, closeLabel, onDismiss, tone = "danger" }) {
  useEffect(() => {
    const timer = window.setTimeout(onDismiss, 1500);
    return () => window.clearTimeout(timer);
  }, [onDismiss]);

  return (
    <div className="aip-noticeViewport">
      <div className={`aip-notice${tone === "info" ? " aip-notice--info" : ""}`}>
        <span className="aip-noticeIcon" aria-hidden="true">{tone === "info" ? "i" : "!"}</span>
        <div className="aip-noticeCopy">
          <p className="aip-noticeMessage" role={tone === "info" ? "status" : "alert"} aria-atomic="true">{message}</p>
          {detail && <p className="aip-noticeDetail">{detail}</p>}
        </div>
        <button type="button" className="aip-closeBtn" aria-label={closeLabel} title={closeLabel} onClick={onDismiss}>×</button>
      </div>
    </div>
  );
}
